__turbopack_context__.v({
  "categoryProducts": "f0hl0W_categoryProducts",
  "categoryProductsCount": "f0hl0W_categoryProductsCount",
  "categoryTitle": "f0hl0W_categoryTitle",
  "promotionCategoryTile": "f0hl0W_promotionCategoryTile",
});
